import * as Yup from 'yup';

import { RemoveIndex } from '../../utils/types';

export const validationSchema = Yup.object().shape({
  notes: Yup.string().nullable().required('Notes is required'),
});

export type FormValues = RemoveIndex<Yup.InferType<typeof validationSchema>>;
